import { processRoleService } from "@features/processRole/processRoleService";
import { ProcessRoleOutputDTO } from "@features/processRole/types";
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: processRoleReducer,
  actions: processRoleActions,
  fetchAll: fetchProcessRoles,
  fetchById: fetchProcessRoleById,
  createEntity: createProcessRole,
  updateEntity: updateProcessRole,
  deleteEntity: deleteProcessRole,
} = createEntitySlice<ProcessRoleOutputDTO>("processRole", processRoleService);

export {
  processRoleReducer,
  processRoleActions,
  fetchProcessRoles,
  fetchProcessRoleById,
  createProcessRole,
  updateProcessRole,
  deleteProcessRole,
};